import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=3ecd16ce"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=3ecd16ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentPaymentCard: require('/home/luiz/Sistemas/loja/components/Payment/PaymentCard/Card.vue').default})
